import { render, staticRenderFns } from "./ZoomImage.vue?vue&type=template&id=cdbb5fa2&"
import script from "./ZoomImage.vue?vue&type=script&lang=js&"
export * from "./ZoomImage.vue?vue&type=script&lang=js&"
import style0 from "./ZoomImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports